module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Home",
    attrs: {
      "id": "Home"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "Homepage row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "row Logo-title"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('h1', [_vm._v("Getting Started")]), _vm._v(" "), _c('p', [_vm._v("Pair'd is an app that will revolutionize the way you find a mentor or mentee!")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('p', [_vm._v("Create a profile describing your interests and lunch preferences.")]), _vm._v(" "), _c('b-button', {
    staticClass: "button-style",
    attrs: {
      "size": "",
      "variant": "primary",
      "href": ""
    }
  }, [_vm._v("\n                    Profile\n                  ")])], 1)]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('p', [_vm._v("Go to the \"Find Mentor/Mentee\" page and click \"Find Match\".")]), _vm._v(" "), _c('b-button', {
    staticClass: "button-style",
    attrs: {
      "size": "",
      "variant": "primary",
      "href": ""
    }
  }, [_vm._v("\n                    Find Mentor\n                  ")])], 1)]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('p')])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/PearLogo.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    attrs: {
      "id": "circle"
    }
  }, [_vm._v("1")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    attrs: {
      "id": "circle"
    }
  }, [_vm._v("2")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    attrs: {
      "id": "circle"
    }
  }, [_vm._v("3")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('p', [_vm._v("Pair'd will match you up with another colleague and will\n                    recommend a restaurant based on your food preferences.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-246bbd84","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 39
// module chunks = 0